import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

@Injectable()
export class PreviousRouteService {

    private previousUrl: string;
    private currentUrl: string;

    constructor(private router: Router) {
        this.currentUrl = this.router.url;
        router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                if (event.url.indexOf('loginview') < 0) {
                    this.previousUrl = this.currentUrl;
                    this.currentUrl = event.url;
                } else {
                    const referrerPath = this.getReferrerPath();
                    if (referrerPath != null && referrerPath.length > 3) {
                        this.previousUrl = this.currentUrl;
                        this.currentUrl = referrerPath;
                    }
                }
            }
        });
    }

    public getReferrerPath() {
        if (document != null && document.referrer && document.baseURI) {
            const thePath = document.referrer.replace(document.baseURI, "/");
            return thePath;
        }
        return null;
    }

    public getPreviousUrl() {
        return this.previousUrl;
    }
}